import { DeliveryMethod } from "../../../state/types"
import { DeliveryOrderList } from "../../delivery-order/delivery-order-list/deliveryOrderList"

export const PickupOrderList = () => {
    return <DeliveryOrderList method={DeliveryMethod.PICKUP} />
}
